export default {"src":"https://images-cdn.curipod.com/d-ee7005b0/_next/static/media/loaderstars.62e39e18.svg","height":669,"width":679};